import React from 'react';
import PropTypes from 'prop-types';

import {Grid} from '@material-ui/core';
import {ArrowBack} from '@material-ui/icons';

import PrimaryButton from '../../../../components/Buttons/PrimaryButton';

const ADD_AND_BACK_TO_SELECTION = 'Hinzufügen und zurück zur Produktauswahl';

/**
 * Standard footer for the selection views: a "back" button plus one or two
 * "confirm" buttons.
 *
 * - `backToSourceLabel` button ("add & back to the source list") is only
 *   relevant while drilled into an item, so it renders when `inDetail`.
 * - `ADD_AND_BACK_TO_SELECTION` button ("add & back to the product picker")
 *   is shown whenever it could be used in the current mode: always in DETAIL,
 *   and in LIST only when whole-item selection is possible
 *   (`withItemSelection`). It stays hidden in the instrument-flow LIST mode,
 *   where there is nothing to commit.
 */
function SelectionFooter({
  onBack,
  onConfirm,
  confirmDisabled,
  inDetail,
  withItemSelection,
  backToSourceLabel,
}) {
  const showAddAndBackToSelection = inDetail || withItemSelection;

  return (
    <>
      <Grid xs={12} sm={'auto'} item>
        <PrimaryButton
          text={'Zurück'}
          icon={<ArrowBack color={'primary'} />}
          variant={'outlined'}
          style={{width: '100%'}}
          onButtonClick={onBack}
        />
      </Grid>

      <Grid xs={12} sm={inDetail ? true : 'auto'} item>
        <Grid container justify="flex-end" spacing={2}>
          {inDetail && (
            <Grid xs={12} sm={'auto'} item>
              <PrimaryButton
                text={backToSourceLabel}
                onButtonClick={onConfirm(false)}
                disabled={confirmDisabled}
                style={{width: '100%'}}
              />
            </Grid>
          )}
          {showAddAndBackToSelection && (
            <Grid xs={12} sm={'auto'} item>
              <PrimaryButton
                text={ADD_AND_BACK_TO_SELECTION}
                onButtonClick={onConfirm(true)}
                disabled={confirmDisabled}
                style={{width: '100%'}}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
}

SelectionFooter.propTypes = {
  onBack: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  confirmDisabled: PropTypes.bool,
  inDetail: PropTypes.bool,
  withItemSelection: PropTypes.bool,
  backToSourceLabel: PropTypes.string,
};

export default SelectionFooter;
